{"library":["https://cdn.minerva.invalid/books/four-great-classics.epub","https://cdn.minerva.invalid/books/journey-to-the-west.epub"]}